/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Kiotviet_Invoice_Date_InvalidInputs */

const vi_error_kiotviet_invoice_date_invalid = /** @type {(inputs: Error_Kiotviet_Invoice_Date_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoá đơn KiotViet thiếu hoặc sai ngày bán nên không đồng bộ lại được.`)
};

/**

* @param {Error_Kiotviet_Invoice_Date_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_kiotviet_invoice_date_invalid = /** @type {((inputs?: Error_Kiotviet_Invoice_Date_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Kiotviet_Invoice_Date_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_kiotviet_invoice_date_invalid(inputs)
});